// extracted by mini-css-extract-plugin
export default {"textInputFlex":"InputFlex_textInputFlex__NdQ8d","textInput1":"InputFlex_textInput1__EpuY6","textInput2":"InputFlex_textInput2__SR+Oq","box1Input":"InputFlex_box1Input__ebGZC"};